import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function ProjectTable() {
  const projects = [
    {
      id: "PRO-001",
      name: "Office Management",
      leader: "Antony",
      team: 3,
      deadline: "12 Sep 2024",
      priority: "Low",
      status: "Active",
    },
    {
      id: "PRO-002",
      name: "Office Management",
      leader: "Antony",
      team: 3,
      deadline: "12 Sep 2024",
      priority: "Medium",
      status: "Inactive",
    },
    {
      id: "PRO-003",
      name: "Office Management",
      leader: "Antony",
      team: 3,
      deadline: "12 Sep 2024",
      priority: "High",
      status: "Active",
    },
    {
      id: "PRO-004",
      name: "Office Management",
      leader: "Antony",
      team: 3,
      deadline: "12 Sep 2024",
      priority: "Low",
      status: "Active",
    },
  ];

  const getPriorityColor = (priority) => {
    if (priority === "Low") return "success";
    if (priority === "Medium") return "info";
    if (priority === "High") return "danger";
  };

  const getStatusColor = (status) => {
    return status === "Active" ? "success" : "danger";
  };

  return (
    <div className="container mt-4">
      {/* Header */}
      <div className="row fw-bold text-muted border p-3 mb-3 bg-light rounded">
        <div className="col">Project ID</div>
        <div className="col">Project Name</div>
        <div className="col">Leader</div>
        <div className="col">Team</div>
        <div className="col">Deadline</div>
        <div className="col">Priority</div>
        <div className="col">Status</div>
      </div>

      {/* Rows */}
      {projects.map((item, index) => (
        <div
          key={index}
          className="row align-items-center p-3 mb-3 shadow-sm rounded bg-white"
        >
          <div className="col">{item.id}</div>

          <div className="col fw-semibold">{item.name}</div>

          <div className="col d-flex align-items-center">
            <img
              src="https://i.pravatar.cc/30"
              alt="avatar"
              className="rounded-circle me-2"
            />
            {item.leader}
          </div>

          <div className="col">
            {[...Array(item.team)].map((_, i) => (
              <img
                key={i}
                src={`https://i.pravatar.cc/30?img=${i + 1}`}
                alt="team"
                className="rounded-circle me-1"
                style={{ width: "30px", height: "30px" }}
              />
            ))}
          </div>

          <div className="col">{item.deadline}</div>

          <div className="col">
            <span className={`badge bg-${getPriorityColor(item.priority)}`}>
              {item.priority}
            </span>
          </div>

          <div className="col">
            <span className={`badge bg-${getStatusColor(item.status)}`}>
              {item.status}
            </span>
          </div>
        </div>
      ))}
    </div>
  );
}

export default ProjectTable;